var _excluded = ["arrowRef", "popoverId", "popoverRef", "singleGroupId", "defaultShow", "show", "placement", "onShow", "onHide", "captureOptions", "onVisibleChange", "onArrowInfoChange", "onPopoverStyleChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAutoControlledBoolean, useElementPosition, useSingleton, useRefCallback, useForceUpdate, useCombineCallback } from '@okee-uikit/react-hooks';
import { Popover, getDefaultTouch } from '../../../models/popper';
import { useGetPopper } from './useGetPopper';
export function usePopover(options) {
  var arrowRef = options.arrowRef,
      popoverId = options.popoverId,
      popoverRef = options.popoverRef,
      singleGroupId = options.singleGroupId,
      _options$defaultShow = options.defaultShow,
      defaultShow = _options$defaultShow === void 0 ? false : _options$defaultShow,
      show = options.show,
      _options$placement = options.placement,
      placement = _options$placement === void 0 ? 'bottom-start' : _options$placement,
      onShow = options.onShow,
      onHide = options.onHide,
      _options$captureOptio = options.captureOptions,
      captureOptions = _options$captureOptio === void 0 ? {} : _options$captureOptio,
      onVisibleChange = options.onVisibleChange,
      onArrowInfoChange = options.onArrowInfoChange,
      onPopoverStyleChange = options.onPopoverStyleChange,
      restOptions = _objectWithoutProperties(options, _excluded);

  var update = useForceUpdate();

  var _useState = useState(getDefaultTouch()),
      _useState2 = _slicedToArray(_useState, 2),
      touch = _useState2[0],
      setTouch = _useState2[1];

  var onArrowInfoChangeCallback = useRefCallback(onArrowInfoChange);
  var onPopoverStyleChangeCallback = useRefCallback(onPopoverStyleChange);

  var _useAutoControlledBoo = useAutoControlledBoolean({
    defaultValue: defaultShow,
    value: show,
    onChange: onVisibleChange,
    onTrue: onShow,
    onFalse: onHide,
    controlled: typeof show !== 'undefined'
  }),
      _useAutoControlledBoo2 = _slicedToArray(_useAutoControlledBoo, 2),
      popperShow = _useAutoControlledBoo2[0],
      onPopperShowChange = _useAutoControlledBoo2[1].setValue;

  var popper = useGetPopper();
  var popover = useSingleton(function () {
    return new Popover({
      popper: popper,
      singleGroupId: singleGroupId,
      id: popoverId,
      options: _objectSpread({
        show: popperShow,
        placement: placement
      }, restOptions)
    });
  });
  useMemo(function () {
    popover.updatePopoverOptions(_objectSpread({
      show: popperShow,
      placement: placement
    }, restOptions));
  }, [popperShow, placement, restOptions.refType, restOptions.refId, restOptions.triggerIds, restOptions.unionPopoverIds, restOptions.offset, restOptions.preventOverflow, restOptions.boundariesDetectionDebounce, restOptions.overflowBoundaries, restOptions.preventAroundOverflow, restOptions.arrow, restOptions.arrowOffset]);
  useElementPosition(popoverRef, function () {
    return popover.isShow();
  }, function (rect) {
    popover.updateRect(rect);
  }, captureOptions);
  useEffect(function () {
    popover.updatePopover(popoverRef.current);
  });
  var handleArrowInfoChange = useCallback(function (arrowInfo) {
    if (arrowRef.current) {
      Object.assign(arrowRef.current.style, arrowInfo.arrowStyle);
    }

    onArrowInfoChangeCallback(arrowInfo);
  }, []);
  var handlePopoverShow = useCombineCallback(onPopperShowChange, function (value) {
    return show && value && update();
  });
  useEffect(function () {
    popover.addListener('popover-show', handlePopoverShow);
    popover.addListener('popover-style', onPopoverStyleChangeCallback);
    popover.addListener('arrow-info-change', handleArrowInfoChange);
    popover.addListener('last-trigger-update', update);
    popover.addListener('touch-change', setTouch);
    return function () {
      popover.removeListener('popover-show', handlePopoverShow);
      popover.removeListener('popover-style', onPopoverStyleChangeCallback);
      popover.removeListener('arrow-info-change', handleArrowInfoChange);
      popover.removeListener('last-trigger-update', update);
      popover.removeListener('touch-change', setTouch);
      popover.dispose();
    };
  }, []);
  return {
    popover: popover,
    touch: touch
  };
}